<template>
  <sl-card v-bind="$attrs" v-on="$listeners" class="master-card" @click.native="goToMaster">
    <v-card-title>
      <!-- style="max-width: 24ch;" -->

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <span class="text-truncate" v-bind="attrs" v-on="on">{{ master.title }}</span>
        </template>
        <span>{{ master.title }}</span>
      </v-tooltip>

      <!-- <sl-aging :master="master"></sl-aging> -->
    </v-card-title>

    <v-card-text class="pb-0">
      <sl-metadata objectType="master" :object="master" />
    </v-card-text>

    <v-card-actions>
      <!-- <sl-btn-master-duplicate :master="master" />
      <v-spacer></v-spacer>
      <sl-btn-instance-create iconAlternative color="primary" :master="master" /> -->
      <v-container class="pa-0">
        <v-row align="center" justify="space-around">
          <v-col xs="12" sm="6" align="center">
            <sl-btn-master-duplicate :master="master" />
          </v-col>
          <v-col xs="12" sm="6" align="center">
            <sl-btn-instance-create icon iconAlternative color="instance" :master="master" />
          </v-col>
        </v-row>
      </v-container>
    </v-card-actions>
  </sl-card>
</template>

<script>
// import SlAging from '@/components/SlAging'
import SlCard from '@/components/SlCard'
import SlBtnMasterDuplicate from '@/components/SlBtnMasterDuplicate'
import SlBtnInstanceCreate from '@/components/SlBtnInstanceCreate'
import SlMetadata from '@/components/SlMetadata'

export default {
  props: {
    master: {
      type: Object,
      required: true,
    },
  },

  components: {
    // SlAging,
    SlCard,
    SlBtnMasterDuplicate,
    SlBtnInstanceCreate,
    SlMetadata,
  },

  data: () => ({
    //
  }),

  computed: {
    //
  },

  methods: {
    goToMaster() {
      this.$router.push({ path: '/model/' + this.master.id })
    },
  },
}
</script>

<style scoped>
.master-card {
  border-color: var(--v-master-base) !important;
}
</style>
